import { render } from "./TanaoroshiWarehouseTransferDetailPage.vue?vue&type=template&id=58ef2c14"
import script from "./TanaoroshiWarehouseTransferDetailPage.vue?vue&type=script&lang=js"
export * from "./TanaoroshiWarehouseTransferDetailPage.vue?vue&type=script&lang=js"

import exportComponent from "/w/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__